import moment from 'moment'
import {camelCase, kebabCase} from 'lodash'

export default {
    name: 'events-item',
    props: {
        item: {
            type: Object,
            default: {}
        },
        index: {
            type: Number
        },
    },
    methods: {
        formattedDate(date) {
            return moment(date).format('DD MMMM, YYYY')
        },
        delayItem(items) {
            let arr = []
            items.forEach(e => {
                arr.push(`${moment(e).format('DD MMM HH:mm')}`)
            })
            return arr.join(' — ')
        },
        toUpperCase(srt) {
            return camelCase(srt)
        },
        createCurrentRoutePath() {
            switch (this.item.service) {
                case 'event': {
                    return {
                        name: 'events-view',
                        params: {
                            slug: this.item.slug
                        }
                    }
                }
                case 'education_material': {
                    switch (this.item.type) {
                        case 'webinar': {
                            return {
                                name: 'webinars-detail',
                                params: {
                                    slug: this.item.slug
                                }
                            }
                        }
                        case 'qa_session': {
                            return {
                                name: 'qa-sessions-detail',
                                params: {
                                    slug: this.item.slug
                                }
                            }
                        }
                        case 'master_class': {
                            return {
                                name: 'master-classes-detail',
                                params: {
                                    slug: this.item.slug
                                }
                            }
                        }
                    }
                    break
                }
                case 'course': {
                    switch (this.item.type) {
                        case 'meetup': {
                            return {
                                name: 'course-material-detail',
                                params: {
                                    item: this.item.course.data.slug,
                                    materialType: `${kebabCase(this.item.type)}s`,
                                    materialSlug: this.item.slug,
                                }
                            }
                        }
                        case 'qa_session': {
                            return {
                                name: 'course-material-detail',
                                params: {
                                    item: this.item.course.data.slug,
                                    materialType: `${kebabCase(this.item.type)}s`,
                                    materialSlug: this.item.slug,
                                }
                            }
                        }
                        case 'event': {
                            return {
                                name: 'course-event-detail',
                                params: {
                                    item: this.item.course.data.slug,
                                    eventSlug: this.item.slug
                                }
                            }
                        }
                        case 'home_work': {
                            return {
                                name: 'home-work-rules',
                                params: {
                                    item: this.item.course.data.slug,
                                    moduleSlug: this.item.module.data.slug,
                                    testId: this.item.slug
                                }
                            }
                        }
                        case 'graduate_work': {
                            return {
                                name: 'graduate-work-rules',
                                params: {
                                    item: this.item.course.data.slug
                                }
                            }
                        }
                    }
                    break
                }
            }
        }
    }
}
